module.exports = __webpack_public_path__ + "static/media/distributor_collboration.4bc00902.png";